import { FeaturedContractors } from "@/components/FeaturedContractors";
import { Contractor } from "@/types/contractor";

interface FeaturedSectionProps {
  contractors: Contractor[];
  showFeatured: boolean;
}

export const FeaturedSection = ({ contractors, showFeatured }: FeaturedSectionProps) => {
  console.log('FeaturedSection rendering with:', {
    contractorsCount: contractors.length,
    showFeatured
  });

  // Don't render anything if we shouldn't show featured
  if (!showFeatured || contractors.length === 0) return null;

  return (
    <div className="bg-gradient-to-b from-[#174996]/5 to-transparent">
      <div className="container py-12">
        <FeaturedContractors contractors={contractors} />
      </div>
    </div>
  );
};